import { Injectable, inject } from '@angular/core';
import { Event, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private router = inject(Router);

  private loaderSubject = new BehaviorSubject<boolean>(false);
  loaderVisible$ = this.loaderSubject.asObservable();
  private showCount = 0;

  constructor() {
    window.onbeforeunload = () => {
      this.show();
    };
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.show();
      } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.hide();
      }
    });
  }

  /**
   * Show the spinner
   */
  show() {
    this.showCount++;
    this.loaderSubject.next(true);
  }

  /**
   * Hide the spinner (when appropriate)
   * @param force true to force the spinner to hide.
   */
  hide(force = false) {
    this.showCount = force ? 0 : Math.max(0, this.showCount - 1);
    this.loaderSubject.next(this.showCount > 0);
  }
}
